export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      noticeDeliveryInfo: {
        noticeDeliveryAt: 1234567890123,
        serviceName: 'アイラ地域サポート',
        deliveryToKbn: 0,
        deliveryStatus: 1,
        deliveryLocationCount: 0,
        openedLocationCount: 0,
        thumbupLocationCount: 0,
        deliverySpCount: 0,
        openedSpCount: 0,
        thumbupSpCount: 0
      },
      deliveryContents: {
        title: '〇〇大会延期のお知らせ',
        body: '8月20日に予定していた〇〇大会を10月28日に延期します。\n事前準備等のスケジュールについては別途お知らせいたしますので、各係の皆様にはよろしくお願いいたします。',
        attachments: [],
        soundFile: [],
        linkUrl: 'http://www.google.co.jp',
        question: 'xxxxx',
        answerOptions: [],
        keikaiLevel: 0
      },
      noticeSenderName: 'アイラ地域サポート',
      deliveryPlanKbn: 3,
      // immediateDelivery: {
      //   deliveryEndDt: '2020-06-05 10:30:00'
      // },
      // reservedDelivery: {
      //   deliveryStartDt: '2020-06-05 10:30:00',
      //   deliveryEndDt: '2020-06-15 10:30:00'
      // },
      repeatedDelivery: {
        deliveryPattern: 127,
        deliveryStartDt: '2020-06-05 10:30:00',
        deliveryEndDt: '2020-06-25 10:30:00'
      },
      noticeTypeMstUuid: 'noticeType006',
      deliveryTypeMstUuid: 'deliverytypemst003'
    }
  }
}